<template>
    <v-container fluid>
    Forma de pagamento
    <br/>
    Valor total: {{productsTotal}}
    <div ref="paypal"></div>	
    </v-container>
</template>

<script>
import Api from '../../services/Api';
import parser from '../../utils/parser';
import router from '../../router/index';
    export default {
        data () {
            return {
                dialog: false,
                loaded: false,
                paidFor: false,
                products: [],
                itens: [],
            }
        },
        computed: {
            productsTotal(){
                return this.$store.getters.productsTotal;
            },
            productsAdded(){
                return this.$store.getters.productsAdded;
            }
        },
        mounted: function () {
            const script = document.createElement("script");
            script.src = "https://www.paypal.com/sdk/js?client-id=AaiF_TxqmmOMXNDzfZuRMcfR4qVcc2hbKR--ttqhS_irsZl6pEvD_vnWc2cdx7lX_YPpmH4ObLK1XVrY&currency=BRL&locale=pt_BR";
            script.addEventListener("load", this.setLoaded);
            document.body.appendChild(script);
            this.productsAdded.forEach(product => {
                this.itens.push({name: product.title, unit_amount: {value: product.price, currency_code:'BRL'}, quantity: '1', sku: product.id})
            });
        },
        methods:{
            setLoaded: function () {
                this.loaded = true;
                window.paypal
                    .Buttons({
                    onClick: (data, actions)  =>{
                        return Api.validateProducts(this.$store.state.auth.token, this.productsAdded)
                            .then(response=>{
                                var productList = parser.getMyProductsToProducts(response);
                                this.itens = [];
                                this.products =  [];
                                productList.forEach(product => {
                                    this.products.push(product);
                                    this.itens.push({name: product.title, unit_amount: {value: product.price, currency_code:'BRL'}, quantity: '1', sku: product.id});
                                    product.isAddedToCart = true;
                                });
                                this.$store.dispatch("UPDATE_PRODUCTS", productList)
                                    .then(()=>{
                                        return actions.resolve();   
                                    });                   
                            })
                            .catch(err=>{
                                console.log("err:"+err);
                                return null;
                            }); 
                    },
                    createOrder: (data, actions) => {                                           
                        return actions.order.create({
                                    purchase_units: [
                                        {   
                                            description: 'Compra de fichas',
                                            amount: {
                                                value: this.productsAdded.length,
                                                currency_code: 'BRL',
                                                breakdown: {
                                                    item_total: {value: this.productsTotal, currency_code: 'BRL'}
                                                }
                                            },
                                            items: this.itens
                                        }                            
                                    ],
                                });                       
                    },
                    onApprove: async (data, actions) => {
                        const order = await actions.order.capture();
                        this.paidFor = true;   
                        this.$store.dispatch('CHECKOUT', ({token: this.$store.state.auth.token, products: this.products,  order: order}))
                            .then(()=>{     
                                router.push("/order");                        
                            })
                            .catch(err=>{
                                console.log("onAprove=>"+err);
                            });                        
                    },
                    onError: (err) => {
                        this.products = [];
                        console.log(err);
                    },
                    })
                    .render(this.$refs.paypal);
            },
        },        
    }
</script>